export function init_gtmtracking() {

    if ("2021.com.au".indexOf(window.location) < 0 )
    {
        return;
    }

    var data = {};

    jQuery(".add_to_cart_button").on("click", function () {
        var productName = jQuery(".product_title").html();
        data = {
            event: "add_to_cart",
            eventLabel: "Add to Cart",
            eventCategory: "Add to Cart",
            eventAction: "Add to Cart",
            productName: productName
        }

        pushtodatalayer(data);
    });

    jQuery(".addtocarttrigger").on("click", function () {
        var productName = jQuery(".product_title").html();
        data = {
            event: "add_to_cart",
            eventLabel: "Add to Cart",
            eventCategory: "Add to Cart",
            eventAction: "Add to Cart",
            productName: productName
        }

        pushtodatalayer(data);
    });

    if (jQuery("body").hasClass("single-product")) {
        var productName = jQuery(".product_title").html();
        data = {
            event: "view_product",
            eventLabel: "View Product",
            eventCategory: "View Product",
            eventAction: "View Product",
            productName: productName
        }

        pushtodatalayer(data);
    }

    jQuery(document).bind("gform_confirmation_loaded", function (e, formid) {
        
       
        var enquirynature = "";//jQuery("#input_4_7 option:selected").val();
        var productName = "";//jQuery("#input_4_8").val();
        var eventName = "";
        var data = {};
        
        console.log(formid);

        if (formid == 4) {
            //general product enquiry
            
            data = {
                event: "generate_lead",
                eventLabel: "Product Enquiry",
                eventName: "Product Enquiry",
                eventCategory: "Product Enquiry",
                eventAction: "Product Enquiry",
                enquiryNature: enquirynature,
                productName: productName
            }
        }

        if (formid == 6) {

            //product review form
            data = {
                event: "generate_lead",
                eventName: "Product Review",
                eventLabel: "Product Review",
                eventCategory: "Product Review",
                eventAction: "Product Review",
                productName: productName
            }
        }

        if (formid == 1) {
            // contact form
            data = {
                event: "generate_lead",
                eventLabel: "Contact Form",
                eventName: "Contact Form",
                eventCategory: "Contact Form",
                eventAction: "Contact Form"
            }
        }

        if (formid == 9) {
            // newsletter signup form
            data = {
                event: "generate_lead",
                eventLabel: "Newsletter Signup",
                eventName: "Newsletter Signup",
                eventCategory: "Newsletter Signup",
                eventAction: "Newsletter Signup"
            }
        }

        if (formid == 8) {
          //  stock enquiry form
            data = {
                event: "generate_lead",
                eventLabel: "Stock Enquiry",
                eventName: "Stock Enquiry",
                eventCategory: "Stock Enquiry",
                eventAction: "Stock Enquiry",
                productName: productName
            }
        }

        pushtodatalayer(data); sendemailalert({data: data, e:e});
    });

}

export function pushtodatalayer(data){

    console.log("pushtodatalayer");
    console.log(data);

    window.dataLayer = window.dataLayer || []; // get or set the dataLayer
    dataLayer.push(data);

}